import React, { useEffect } from 'react';
import { IDataTable, ModeMyProfile, MyProfileProps } from "./MyProfile.props";
import { Box, Card, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import './MyProfile.css';
import { styled } from '@mui/material/styles';
import {
  toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup';
import { CardContent, Divider } from '@mui/material';
import HalfPieChart from "../HalfPieChart/HalfPieChart"; 
import { UserAvatarLetters } from "../UserAvatarLetters";
import { getCurrentCellStore, getUserName } from "../../utils/util";
import { useAppSelector } from "../../redux/hooks";
import { userAcceptEventsDataSelector } from "../../redux/userAcceptSlice";
import { images } from "../../constants/images";
import { workSpaceEventsDataSelector } from "../../redux/workSpaceSlice";
import { useDispatch } from 'react-redux';
import ChangeWorkSpace from '../../hoc/changeWorkSpace';

const userData = { fullname: 'Learner', avatar: images.NoAvatar };

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  color: 'black',
  backgroundColor: '#cccfcf',
  '&.Mui-selected': {
    color: 'white',
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  '&.MuiButtonBase-root': {
    borderRadius: '24px',
    fontSize: 14,
    fontWeight: 500,
    height: '32px',
    padding: 16,
    border: 0,
  },
  '&:hover': {
    backgroundColor: '#cccfcf',
  },
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: '1px solid transparent',
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
  {
    marginLeft: -1,
  },
}));

const MyProfileComponent: React.FC<MyProfileProps> = ({profileData, learnerName, isManagerView,cellStore}) => {
  const dispatch = useDispatch<any>();
  const { dataUserAccept } = useAppSelector(userAcceptEventsDataSelector);
  const userCurrentCellStore = cellStore ?? getCurrentCellStore();
  const defaultValue: "courses" | "email" = userCurrentCellStore?.show_training_data ? "courses" : userCurrentCellStore?.show_phishing_data ? "email" : "courses";
  const [valueTable, setValueTable] = React.useState<"courses" | "email">(defaultValue);
  const [dataAccept, setDataAccept] = React.useState(false);
  const { workSpaceData } = useAppSelector(workSpaceEventsDataSelector);
  const displayName = isManagerView && learnerName ? learnerName : getUserName(userCurrentCellStore);

  const handleChange = (event: any, newValue: "courses" | "email") => {
    if (newValue !== null) {
      setValueTable(newValue)
    }
  };

  const dataTables: Record<ModeMyProfile, IDataTable> = {
    courses: {
      title: { label: 'Course Completion:', value: profileData?.courses?.course_completion ?? 0 },
      details: [
        { label: 'Assigned', value: profileData?.courses?.assigned_course_quantity ?? 0 },
        { label: 'Completed', value: profileData?.courses?.completed_course_quantity ?? 0 },
        { label: 'Pending', value: profileData?.courses?.pending_course_quantity ?? 0 },
      ],
    },
    email: {
      title: { label: 'Click Through Rate:', value: profileData?.email?.click_through_rate_percentage ?? 0 },
      details: [
        { label: 'Delivered', value: profileData?.email?.delivered ?? 0 },
        { label: 'Reported', value: profileData?.email?.reported ?? 0 },
        { label: 'Clicked', value: profileData?.email?.clicked ?? 0 },
      ],
    },
  };

const avatarImage = (isAccept: boolean) => {
  if (isManagerView && learnerName) {
    return <UserAvatarLetters classNames={'profile-avatar'} name={learnerName} />;
  }
  const getName = getUserName(userCurrentCellStore);
  if (userCurrentCellStore && getName && isAccept) {
    return <UserAvatarLetters classNames={'profile-avatar'} name={getUserName(userCurrentCellStore)} />;
  } else {
    return (
      <div className="profile-avatar-sample">
        <img className="profile-picture" src={userData.avatar} alt="avatar" />
      </div>
    );
  }
};

  useEffect(() => {
    setDataAccept(dataUserAccept.isAccept)
  }, [dispatch, dataUserAccept?.isAccept, workSpaceData])


  return (
    <>
      <div className={'my-profile'}>
        <Box width={'100%'} display="flex" justifyContent="space-between" mb={'37px'}>
          <Typography sx={{ fontFamily: 'Righteous', fontSize: 24, fontWeight: 40, color: '#193051' }}>My
            Profile</Typography>
          <Typography>
          </Typography>
        </Box>
        <div className={'info'}>
          {
            avatarImage(dataAccept)
          }
          <Typography
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontWeight: 700,
              lineHeight: '32px',
              letterSpacing: '0em',
              textAlign: 'left',
              color: '#000000',
              marginTop: '15px'
            }}
          >
            {displayName}
          </Typography>
          {profileData?.department && (
            <Typography
              sx={{
                color: '#000000',
                opacity: 0.9
              }}
            >
              Department: {profileData.department}
            </Typography>
          )}
          {profileData?.show_phishfit_score === true && (
            <HalfPieChart valueScore={profileData.score_profile} />
          )}
          {(userCurrentCellStore?.show_training_data || userCurrentCellStore?.show_phishing_data) && (
            <>
              <Divider sx={{ width: '100%', margin: '24px 0' }} />

              {valueTable && (
                <StyledToggleButtonGroup
                  value={valueTable}
                  exclusive
                  onChange={handleChange}
                  aria-label="Selection"
                  sx={{ gap: 2, marginBottom: '25px' }}
                >
                  {userCurrentCellStore?.show_training_data && (
                    <CustomToggleButton value="courses" aria-label="courses">
                      Course
                    </CustomToggleButton>
                  )}
                  {userCurrentCellStore?.show_phishing_data && (
                    <CustomToggleButton value="email" aria-label="email">
                      Email
                    </CustomToggleButton>
                  )}
                </StyledToggleButtonGroup>
              )}

              <Card
                variant="outlined"
                sx={{ width: '100%', borderRadius: 1, backgroundColor: '#F6F6F6' }}
              >
                <CardContent sx={{ padding: '0 24px' }}>
                  {/* Header */}
                  <Box display="flex" justifyContent="space-between" p={'23px 0'}>
                    <Typography>
                      {dataTables[valueTable as ModeMyProfile].title.label}
                    </Typography>
                    <Typography>
                      {dataTables[valueTable as ModeMyProfile].title.value}%
                    </Typography>
                  </Box>

                  <Divider />

                  {/* Content */}
                  {dataTables[valueTable as ModeMyProfile].details.map((item: any, index: number) => (
                    <Box key={index} display="flex" justifyContent="space-between" p={'23px 0'}>
                      <Typography>{item.label}</Typography>
                      <Typography>{item.value}</Typography>
                    </Box>
                  ))}
                </CardContent>
              </Card>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export const MyProfile = ChangeWorkSpace(MyProfileComponent);
